<template>
  <div>
    <a-divider />
    <a-card :bordered="false">
      <a-row type="flex" justify="space-between">
        <a-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
          <div class="login-wrap">
            <Register/>
          </div>
        </a-col>
        <a-col :xs="0" :sm="0" :md="0" :lg="13" :xl="13">
          <img
            style="width:100%"
            class="cover"
            v-if="tenantInfo.loginBg"
            :src="tenantInfo.qiniuDomain + '/' + tenantInfo.loginBg"
            alt=""
          />
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Register from './user/Register'
export default {
  components:{
    Register
  },
  data() {
    return {
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
   mounted(){
    window.document.title = this.tenantConfig.brandName + " " + "注册"
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>

.login-wrap{
  padding: 10px 40px;
}
</style>